import { useEffect, useState } from "react";
import "../styles/MainHero.css";

// Responsive Hero image hook
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
}

export default function MainHero() {
  const [awardData, setAwardData] = useState([]);
  const [heroData, setHeroData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isMobile = useIsMobile();

  useEffect(() => {
    const fetchAwards = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/images/main`,
        );

        if (!res.ok) {
          throw new Error(res.message || "Failed to fetch images");
        }

        const data = await res.json();

        setHeroData(data.data.header);
        setAwardData(data.data.award);
      } catch (err) {
        setError(err.message || "Failed to fetch images");
      } finally {
        setLoading(false);
      }
    };
    fetchAwards();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  if (!awardData || awardData.length < 2) {
    return <div>Loading awards...</div>;
  }

  const heroImage = isMobile ? heroData[1].src : heroData[0].src;

  return (
    <header className="hero">
      <div className="hero__container ">
        <div
          className="hero__image"
          style={{
            backgroundImage: `
      linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0)),
      url(${heroImage})
    `,
          }}
        >
          <div className="hero__content">
            <h1>Creating Beautiful Luxury Picnics For Your Special Occasion</h1>
            <h3>
              Simply choose your picnic style, date, time and location and leave
              the rest to us
            </h3>
          </div>
          <div className="hero_award--container-left">
            <img
              className="hero_award--image"
              src={awardData[0].src}
              alt={awardData[0].alt}
            />
          </div>
          <div className="hero_award--container-right">
            <img
              className="hero_award--image"
              src={awardData[1].src}
              alt={awardData[1].alt}
            />
          </div>
        </div>
      </div>
    </header>
  );
}
